import { render, staticRenderFns } from "./Fundingsupport.vue?vue&type=template&id=e86fe2a8&scoped=true&"
import script from "./Fundingsupport.vue?vue&type=script&lang=js&"
export * from "./Fundingsupport.vue?vue&type=script&lang=js&"
import style0 from "./Fundingsupport.vue?vue&type=style&index=0&id=e86fe2a8&scoped=true&lang=css&"
import style1 from "./Fundingsupport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86fe2a8",
  null
  
)

export default component.exports